/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { AuthContext } from '../context/AuthContext';

const localizer = momentLocalizer(moment);

const ScheduleManagementPage = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user) return;
    setLoading(true);
    api.get('/schedules')
      .then(res => {
        const evs = res.data.map(e => ({
          id: e.id,
          title: e.title,
          start: new Date(e.start),
          end: new Date(e.end)
        }));
        setEvents(evs);
        setError(null);
      })
      .catch(err => {
        console.error(err);
        setError(err.response?.data?.error || 'Failed to load schedules');
      })
      .finally(() => setLoading(false));
  }, [user]);

  if (loading) return <div className="p-6">Loading schedules...</div>;
  if (error) return <div className="p-6 text-red-500">{error}</div>;

  const handleDeleteEvent = async (eventId) => {
    try {
      await api.delete(`/schedules/${eventId}`);
      // Remove the event from the local state
      setEvents(prevEvents => prevEvents.filter(event => event.id !== eventId));
      alert('Event deleted successfully');
    } catch (err) {
      console.error(err);
      alert('Failed to delete event: ' + (err.response?.data?.error || err.message));
    }
  };

// No need to handle single click anymore since we removed selectedEvent state

  const handleEventSelect = (event) => {
    if (window.confirm('Are you sure you want to delete this event?')) {
      handleDeleteEvent(event.id);
    }
  };

  const handleDayClick = (date) => {
    const newEvent = {
      start: date,
      end: new Date(date.getTime() + 60 * 60 * 1000), // Add 1 hour by default
    };
    navigate(user.role === 'admin' ? '/admin/dashboard/schedule/new' : '/teachers/dashboard/schedule/new', {
      state: { initialDate: newEvent }
    });
  };

  return (
    <div className="p-6">
      <h1 className="text-2xl mb-4">Schedule</h1>
      <button onClick={() => navigate(user.role === 'admin' ? '/admin/dashboard/schedule/new' : '/teachers/dashboard/schedule/new')} className="bg-blue-500 text-white px-4 py-2 rounded mb-4">
        New Event
      </button>
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        onDoubleClickEvent={handleEventSelect}
        onSelectSlot={handleDayClick}
      />
    </div>
  );
};

export default ScheduleManagementPage;
